<template>
  <div v-if="isAdmin" class="obra-admin-controls" aria-label="Controles administrativos">
    <AgeRatingPickerModal :value="ageRatingIds" :ageRatings="ageRatings" @input="$emit('age-rating-picked', $event)" />
  </div>
</template>

<script>
import AgeRatingPickerModal from '@/components/AgeRatingPickerModal.vue';

export default {
  name: 'ObraAdminControls',
  components: { AgeRatingPickerModal },
  props: {
    isAdmin: { type: Boolean, default: false },
    ageRatingIds: { type: Array, default: () => [] },
    ageRatings: { type: Array, default: () => [] },
  },
};
</script>
